import React from "react";
import "../RightToCorrect/updateInfoInMy.css";
import "../RightToCorrect/rightToCorrect.css";
import PropTypes from "prop-types";

const ButtonIntruction = ({
  link,
  buttonText,
  instructionTitle,
  instructions,
}) => {
  return (
    <div className="u-m-none right-to-correct-wrapper">
      <div className="instructions-block o-layout u-1/1 u-m-none">
        <div className="instructions-cta o-layout__item u-1/3 u-1/1@s u-p-none u-pr u-text-center@s">
          <a
            className="a-link-cta"
            href={link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="c-btn  c-btn--secondary  c-btn--icon block-cta">
              <span className="c-btn__text u-font-size-fs0">{buttonText}</span>

              <div className="box-outside-arrow-up-right" />
            </button>
          </a>
        </div>

        <div className="instructions-list o-layout__item u-2/3 u-1/1@s u-p-none@s">
          <p className="intructions-title u-mb-xxsmall u-font-size-fs0">
            {instructionTitle}
          </p>

          {instructions}
        </div>
      </div>
    </div>
  );
};

ButtonIntruction.propTypes = {
  link: PropTypes.string,
  buttonText: PropTypes.string,
  instructionTitle: PropTypes.string,
  instructions: PropTypes.node,
};

export default ButtonIntruction;
